// Multipart-upload via rechtstreekse fetch — apiFetch zet altijd
// Content-Type: application/json, wat een multipart-upload breekt.
export async function uploadFile(path, file) {
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";
  const sessionKey = Object.keys(localStorage).find((k) => k.endsWith("-auth-token"));
  const sessionData = sessionKey ? JSON.parse(localStorage.getItem(sessionKey) || "{}") : {};
  const accessToken = sessionData?.access_token;

  const formData = new FormData();
  formData.append("file", file);

  const res = await fetch(`${API_URL}${path}`, {
    method: "POST",
    body: formData,
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`API-fout ${res.status}: ${text}`);
  }
  return res.json();
}
